// could be used as a type in future
export enum SipActionType {
  CALL_ANSWER = 'call_answer',
}
